import request from '@/utils/request'
export function getDepartmentList(name,page) {
  return request({
    url:'/api/department/depart-ment?departName='+name+'&page='+page,
    method:'get',
  })
}
export function getDepartmentRelationByName(fullName,isBussiness) {
  return request({
    url:'/api/department/depart-relation?fullName='+fullName+'&isBussiness='+isBussiness,
    method:'get',
  })
}

export function getDepartmentRelationByStructs(fullName,positionName,isBussiness) {
  return request({
    url:'/api/department/depart-structs?fullName='+fullName+'&positionName='+positionName+'&isBussiness='+isBussiness,
    method:'get',
  })
}


export function getDepartmentRelationById(deptId) {
  return request({
    url:'/api/department/'+deptId+'/depart-relation',
    method:'get',
  })
}
export function getDepartmentInfo(deptId) {
  return request({
    url:'api/department/depart-info?deptId='+deptId,
    method:'get',
  })
}
export function GetDepartmentByDepId(deptId,isBussiness) {
  return request({
    url:'api/department/department-deptId?deptId='+deptId+'&isBussiness='+isBussiness,
    method:'get',
  })
}





